module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/calendar-19ceb5906ce3052524a5ec4fa15a49f8.svg&quot;;"